






























import { Vue, Component, Prop, Inject } from "vue-property-decorator";
import { IClient } from "@/models/clients";
import { IClientProviderData } from "@/models/providers/client";
import { IAccount } from "@/models/accounts";

@Component({
  components: {
    "tickets-table": () =>
      import("@/components/app/global/tickets/ticketsTable.vue")
  }
})
export default class AdminClientTicketsView extends Vue {
  @Inject({ from: "clientProvider" })
  public readonly $clientProvider!: () => IClientProviderData;

  @Prop({ required: true })
  public client!: IClient;

  @Prop({ default: () => () => [] })
  public routes!: () => any;

  public get isStaged() {
    return this.$clientProvider().isStaged;
  }

  public get cta() {
    return this.$t("_action.open_new_ticket", {
      object: (this.$t("_.ticket") as string).toLowerCase()
    });
  }

  public addTicket() {
    this.$store.dispatch("data/tickets/openNewTicketModal", {
      clientId: this.$_.get(this.client, "id") as IClient["id"],
      accountId: this.$_.get(this.client, "accounts[0].id") as IAccount["id"],
      brandId: this.$_.get(this.client, "brand_id")
    });
  }
}
